import { useEffect, useRef, useState } from 'react';
import { fetchText } from '../lib/api';

/**
 * Figurinha animada do WhatsApp (animação Lottie). A animação vem da API (com o token) e o player
 * (versão leve, sem eval) só é carregado quando aparece uma figurinha dessas.
 */
export function LottieSticker({ path, className }: { path: string; className?: string }) {
  const box = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let destroyed = false;
    let anim: { destroy(): void } | null = null;
    void (async () => {
      try {
        const [{ default: lottie }, text] = await Promise.all([import('lottie-web/build/player/lottie_light'), fetchText(path)]);
        if (destroyed || !box.current) return;
        anim = lottie.loadAnimation({ container: box.current, renderer: 'svg', loop: true, autoplay: true, animationData: JSON.parse(text) });
      } catch (err) {
        console.warn('Figurinha animada não exibida:', err);
        if (!destroyed) setFailed(true);
      }
    })();
    return () => {
      destroyed = true;
      anim?.destroy();
    };
  }, [path]);

  if (failed) return <span className="text-xs text-fg-soft italic">Figurinha animada (não foi possível exibir)</span>;
  return <div ref={box} className={className} title="Figurinha animada" />;
}
